import { createSelector } from 'reselect';
import { IPLUMenusState, IPLUMenuState } from './types';

export const selectSyncState = (state: IPLUMenusState) => state.syncing;
export const selectLoadedState = (state: IPLUMenusState) => state.loaded;
export const selectSyncError = (state: IPLUMenusState) => state.error;

export const selectPLUMenus = (state: IPLUMenusState) => state.pluMenus;
export const selectPLUMenuItem = (state: IPLUMenusState) => state.pluMenu;
export const selectPluAssociatedGroups = (state: IPLUMenusState) => state.pluAssociatedGroups;

export const selectCreateInitiatedState = (state: IPLUMenusState) => state.createInitiated;
export const selectUpdateInitiatedState = (state: IPLUMenusState) => state.updateInitiated;
export const selectDeleteInitiatedState = (state: IPLUMenusState) => state.deleteInitiated;

export const selectCreatedState = (state: IPLUMenusState) => state.pluMenuCreated;
export const selectUpdatedState = (state: IPLUMenusState) => state.pluMenuUpdated;
export const selectDeletedState = (state: IPLUMenusState) => state.pluMenuDeleted;

export const selectIndexedPLUMenus = createSelector(selectPLUMenus, (pluMenus) =>
  pluMenus.reduce((indexed: { [key: string]: IPLUMenuState }, pluMenu: IPLUMenuState) => {
    if (pluMenu.pluMenuId) {
      indexed[pluMenu.pluMenuId] = pluMenu;
    }
    return indexed;
  }, {})
);
export const selectPLUMenu = createSelector(
  [selectIndexedPLUMenus, (_: IPLUMenusState, id: string) => id],
  (indexedPLUMenus, id) => indexedPLUMenus[id]
);
